import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["type", "label", "propsToDisplay", "elementTitle"];
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { MainContext } from '@blaze-cms/nextjs-components';
import { TextSearch, Checkbox, SelectFilter, Range } from '../components';
import { CHECKBOX, SELECT, TEXT_SEARCH, RANGE, SEARCH_TERM } from '../constants';
const FiltersList = ({
  data,
  filters,
  hasUrl,
  entity,
  filterValues,
  updateFilterValues,
  shouldSearch
}) => {
  const {
    itemId
  } = useContext(MainContext);
  return filters.map((_ref, index) => {
    let {
        type,
        label,
        propsToDisplay,
        elementTitle
      } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded);
    if (!propsToDisplay && !propsToDisplay.length) return null;
    const dynamicKey = [itemId, index].join('-');
    const isDataAvailable = !!data && Object.keys(data).length;
    const dataAggregations = isDataAvailable ? data : null;
    const areAggregationsAvailable = isDataAvailable && !!dataAggregations;
    switch (type) {
      case TEXT_SEARCH:
        return /*#__PURE__*/React.createElement("div", {
          key: dynamicKey,
          className: "filter__section filter__section--search-refine filter__section--search"
        }, /*#__PURE__*/React.createElement(TextSearch, _extends({}, otherProps, {
          label: label,
          elementTitle: elementTitle,
          searchValue: filterValues[SEARCH_TERM],
          updateFilterValues: updateFilterValues,
          filterValues: filterValues
        })));
      case CHECKBOX:
        return /*#__PURE__*/React.createElement("div", {
          key: dynamicKey,
          className: "filter__section filter__section--search-refine filter__section--checkboxes"
        }, /*#__PURE__*/React.createElement(Checkbox, _extends({}, otherProps, {
          data: data,
          prop: propsToDisplay[0],
          label: label,
          elementTitle: elementTitle,
          hasUrl: hasUrl,
          filterValues: filterValues,
          updateFilterValues: updateFilterValues,
          shouldSearch: shouldSearch
        })));
      case SELECT:
        return /*#__PURE__*/React.createElement("div", {
          key: dynamicKey,
          className: "filter__section filter__section--search-refine filter__section--selects"
        }, /*#__PURE__*/React.createElement(SelectFilter, _extends({}, otherProps, {
          data: data,
          prop: propsToDisplay[0],
          label: label,
          elementTitle: elementTitle,
          hasUrl: hasUrl,
          filterValues: filterValues,
          updateFilterValues: updateFilterValues,
          shouldSearch: shouldSearch
        })));
      case RANGE:
        return !!areAggregationsAvailable && /*#__PURE__*/React.createElement("div", {
          key: dynamicKey,
          className: "range-slider__wrapper"
        }, /*#__PURE__*/React.createElement(Range, _extends({}, otherProps, {
          dataAggregations: dataAggregations,
          propsToDisplay: propsToDisplay,
          label: label,
          elementTitle: elementTitle,
          entity: entity,
          filterValues: filterValues,
          updateFilterValues: updateFilterValues,
          shouldSearch: shouldSearch
        })));
      default:
        return null;
    }
  });
};
FiltersList.propTypes = {
  hasUrl: PropTypes.bool.isRequired,
  entity: PropTypes.string.isRequired,
  filterValues: PropTypes.object.isRequired,
  updateFilterValues: PropTypes.func.isRequired,
  data: PropTypes.object,
  filters: PropTypes.array,
  shouldSearch: PropTypes.bool
};
FiltersList.defaultProps = {
  shouldSearch: false,
  data: {},
  filters: []
};
export default FiltersList;
//# sourceMappingURL=FiltersList.js.map